/**
 * What the live client does when its socket closes (docs/SYNC.md §5.5).
 *
 * The server closes with 1008 (policy violation, the websocket's 401) exactly
 * when the socket's session stands for no one: the upgrade found no session, or
 * the heartbeat found the session gone, expired or belonging to a deleted
 * account (src/realtime/server.ts). Another connection would be refused the same
 * way, so the client does not reconnect; it asks the page for one refresh, and a
 * page that needs a viewer then sends the browser to sign-in. Every other close
 * (a dropped network, a restarting server, a client that sent too much) is
 * answered by reconnecting with backoff.
 */
export const SESSION_ENDED_CLOSE = 1008;

export type LiveCloseOutcome = 'reconnect' | 'session-ended';

export function liveCloseOutcome(code: number): LiveCloseOutcome {
  return code === SESSION_ENDED_CLOSE ? 'session-ended' : 'reconnect';
}
